import React from "react"
import MetaTags from 'react-meta-tags';
import { Container, Row } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import BlogGrid from "./BlogGrid"
import RightBar from "../BlogList/RightBar"

const Index = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Parenting App| Journals</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Blog" breadcrumbItem="Blog Grid" />
          <Row>
            {/* <BlogGrid /> */}
            {/* <RightBar /> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Index
